// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Details_wrapper__rtfnd"};